import { jsx } from "react/jsx-runtime";
import { Group as Group$1 } from "@zillow/zrs-cms";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const Group = Group$1;
const BlockGroup = ({
  attrs,
  innerBlocks
}) => {
  const {
    alignItems = {
      default: "stretch"
    },
    backgroundImage,
    backgroundImageVisible = {
      default: true,
      lg_lte: true,
      sm_lte: true
    },
    backgroundPosition,
    backgroundSize,
    borderRadius,
    // Only default fontColor to textDark when the Group has an explicit
    // backgroundColor. A Group with a background creates its own color
    // context (e.g. a white card inside a teal section) and its children
    // must not inherit the ancestor's textWhite. A Group with no
    // backgroundColor is a pure layout container — omitting fontColor lets
    // children correctly inherit from the nearest colored ancestor.
    // NOTE: backgroundColor is intentionally NOT destructured here — it
    // must remain in ...groupProps so it is forwarded to <Group>.
    fontColor = attrs.backgroundColor ? {
      default: "textDark"
    } : void 0,
    justifyContent = {
      default: "center"
    },
    loading = "lazy",
    margin = {
      marginBottom: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      }
    },
    maxWidth = {
      default: "xl"
    },
    padding = {
      paddingTop: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      },
      paddingBottom: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      },
      paddingRight: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      },
      paddingLeft: {
        default: "lg",
        lg_lte: "md",
        sm_lte: "sm"
      }
    },
    ...groupProps
  } = attrs;
  return /* @__PURE__ */ jsx(Group, { alignItems, backgroundImage, backgroundImageVisible, backgroundPosition, backgroundSize, fontColor, justifyContent, loading, maxWidth, borderRadius, ...groupProps, ...margin, padding, children: generateBlockList({
    blocks: innerBlocks
  }) });
};
export {
  BlockGroup as default
};
